import * as React from 'react';
import styles from './index.less';
import FInput_Search from '@/components/FInput_Search';
import Resource from './Resource';
import User from './User';
import { FUtil } from '@freelog/tools-lib';
import useUrlState from '@/hooks/useUrlState';

interface SearchProps {}

function Search({}: SearchProps) {
  const [{ search }] = useUrlState<{ search: string }>({ search: '' });

  const [$search, set$search, get$search] = FUtil.Hook.useGetState<string>(search);
  const [$tab, set$tab, get$tab] = FUtil.Hook.useGetState<'resource' | 'user'>('resource');

  return (
    <div className={styles.styles}>
      <div className={styles.header}>
        <div style={{ height: 40 }} />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <FInput_Search
            value={$search}
            style={{ width: 500 }}
            onChange={(e) => {
              set$search(e.target.value);
            }}
          />
        </div>
        <div style={{ height: 40 }} />
        <div className={styles.tab}>
          <div
            className={[styles.item, $tab === 'resource' ? styles.activated : ''].join(' ')}
            onClick={() => {
              set$tab('resource');
            }}
          >
            资源
          </div>
          <div
            className={[styles.item, $tab === 'user' ? styles.activated : ''].join(' ')}
            onClick={() => {
              set$tab('user');
            }}
          >
            用户
          </div>
        </div>
      </div>
      <div className={styles.body}>
        {$tab === 'resource' && <Resource search={$search} />}

        {$tab === 'user' && <User search={$search} />}
      </div>
    </div>
  );
}

export default Search;
